import { useRef, useState, type ReactNode } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

const TooltipBubble = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 1001;
  background: var(--mid-blue);
  color: white;
  font-size: 14px;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  transform: translateX(-50%);
  border: 1px solid var(--dark-blue);

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid var(--mid-blue);
  }
`;

type HoverTooltipProps = {
  text: string;
  children: ReactNode;
};

export const HoverTooltip = ({ text, children }: HoverTooltipProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setPosition({ x: rect.left + rect.width / 2, y: rect.bottom + 6 });
    }
    setVisible(true);
  };

  return (
    <span
      ref={ref}
      style={{ display: 'inline-flex', width: 'fit-content' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible &&
        ReactDOM.createPortal(
          <TooltipBubble style={{ left: position.x, top: position.y }}>
            {text}
          </TooltipBubble>,
          document.body
        )}
    </span>
  );
};
